import React from "react";
import style from "./StoreButtons.module.css";
import PropTypes from "prop-types";

export default function AppStore({ appLink }) {
  return (
    <a className={`${style.appBtn} ${style.blu} ${style.flex}`} href={appLink}>
      <i class={`mdi mdi-apple ${style.icon}`}></i>
      <p className={style.btnBox}>
        <span className={style.smallTxt}> Available on the </span>
        <br />
        <span class={`${style.bigTxt}`}>App Store</span>
      </p>
    </a>
  );
}

AppStore.propTypes = {
  appLink: PropTypes.string,
};
